import { render, staticRenderFns } from "./MyTeams.vue?vue&type=template&id=7a1d7905&"
import script from "./MyTeams.vue?vue&type=script&lang=js&"
export * from "./MyTeams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports